const TRadio = {
  baseClass: ''
}

export default TRadio
